import { render, staticRenderFns } from "./ResearchContextSearch.vue?vue&type=template&id=567c1a24&scoped=true"
import script from "./ResearchContextSearch.vue?vue&type=script&lang=js"
export * from "./ResearchContextSearch.vue?vue&type=script&lang=js"
import style0 from "./ResearchContextSearch.vue?vue&type=style&index=0&id=567c1a24&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c1a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567c1a24')) {
      api.createRecord('567c1a24', component.options)
    } else {
      api.reload('567c1a24', component.options)
    }
    module.hot.accept("./ResearchContextSearch.vue?vue&type=template&id=567c1a24&scoped=true", function () {
      api.rerender('567c1a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchContextSearch.vue"
export default component.exports